module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/02-9366ca43808fc4389b2ced4b669c44fd.jpg";